/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerRankComponent', [
    'DesignerComponent',
    'DesignerSchema',

    function (DesignerComponent, DesignerSchema) {
      function DesignerRankComponent() {
        DesignerComponent.apply(this);

        this.dense = null;
        this.field_alias = null;
        this.data_order = null;
        this.fields = [];
      }

      DesignerRankComponent.prototype = new DesignerComponent();

      DesignerRankComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          dense: this.dense || false,
          field_alias: this.field_alias || 'rank',
          fields: this.fields || [],
        });

        data.data_order = data.fields.length ? 'sort' : 'no_sort';

        return data;
      };

      DesignerRankComponent.prototype.setFormData = function (data) {
        // if (data.data_order === 'no_sort') {
        //     data.fields = [];
        // }

        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerRankComponent.prototype.setData = function (data) {
        this.dense = data.dense;
        this.field_alias = data.field_alias;
        this.data_order = data.data_order;
        this.fields = data.fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerRankComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();
        schema.id = this.id;
        schema.name = this.name;

        schema.addField({
          name: this.field_alias,
          data_type: 'int',
        });

        const parentSchema = this.getParentSchema();

        _.each(parentSchema.fields, function (field) {
          schema.addField({
            name: field.name,
            data_type: field.data_type,
          });
        });

        return schema;
      };

      return DesignerRankComponent;
    },
  ]);
})(window.angular);
